// extracted by mini-css-extract-plugin
export default {"modal":"click-and-collect-cut-off-passed-modal_modal__4c6f4"};